module.exports = __webpack_public_path__ + "img/intro2.0aebd17e.png";